import { Injectable } from "@angular/core";
import { MissingLocalizationHandlerParams } from "./localizaton.model";



@Injectable({ providedIn: 'root' })
export class MissingLocalizationHandler {
  handle(params: MissingLocalizationHandlerParams): string {
    return params.key;
  }
}
